
    <template>

    <div>

            <div style="margin-left:5px;margin-top: 0px; max-height:230px; position: relative;">
                <!-- the brief version -->
                <div style=" width:100%;">
                    <div  style="position:absolute;left:5px;top:7px"><img style="height:30px;width:30px" src="/assets/icons/horses-mouth.png"/></div>
                        <div class="grid-x vertical-align text-center" style="padding-top:5px; padding-left:5px;padding-right: 5px"> 
                            <div class="cell small-2 qmajorheader"></div>
                            <div class="cell auto qmajorheader qsmallfontplus1" v-html="langConv('Betting News')"></div>
                            <div class="cell shrink qmajorheader" style="padding-top:5px;padding-right:5px"><actionbutton routerlinkpath="/Horses-Mouth" buttontext="more" ></actionbutton></div>
                        </div> 
                    </div>
                </div>
                <div v-if="param1 == 'brief'" style="overflow:auto; height:220px">
                    <blogview view="brief"/>
                </div>
         
            </div>
           
    </template>



<script>

    import blogview from '../components/blogview.vue';
    import tab from '../modified3rdpartycomponents/tab.vue'
    import tabs from '../modified3rdpartycomponents/tabs.vue'
    

    export default {
        name: "horsesmouth",
        data: function data() {
            return {


            }
        },
        components: {

            blogview


        },
        created() {

        },



        props: {
            param1: {type: String, default: "0"}
        },
         methods: {
           changeBlogView: function changeBlogView(newVal) {

                if (this.blogviewval == newVal.tab.id) {
                    return;
                } else {
                    this.blogviewval = newVal.tab.id;
                }
            }


        }
    }

</script>